// Copyright Mark Skiba, 2025 All rights reserved

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
// Initialize WebSocket debugger to suppress expected connection failures
import './utils/websocketDebugger';
// Initialize function status verifier in development
import './utils/functionStatusVerifier';
// Initialize Claude streaming test function for development
import './utils/claudeStreamingTester';
// Initialize agent switch debugging tools for development
import './utils/agentSwitchTestUtil';
import './utils/agentSwitchHelp';
// Initialize Supabase health checker for debugging
import './utils/supabaseHealthChecker';

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <App />
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onSuccess: (registration) => {
    console.log('SW registered: ', registration);
  },
  onUpdate: (registration) => {
    console.log('SW updated: ', registration);
    // The update will be handled by PWAUpdatePrompt component
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
